export default __webpack_public_path__ + "static/media/my-hospitalization.a8961c87.png";